import { isBrowser } from './isBrowser';
export var isServer = !isBrowser;
//# sourceMappingURL=isServer.js.map